<app-header></app-header>
<ion-content
  id="request-credit"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <div class="request-credit-header">
    <ion-grid [fixed]="true">
      <!-- Row for Breadcrumbs -->
      <ion-row
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        class="breadcrumbs-row"
      >
        <ion-col size="12">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>

      <!-- Row for Header -->
      <ion-row class="title-row">
        <ion-col size="12">
          <h2
            data-cy="request-credit-page-header-text"
            *ngIf="!serviceRequestService.isPickUp"
          >
            {{ 'i18n.requestCredit.title' | translate }}
          </h2>
          <h2
            data-cy="pickup-request-page-header-text"
            *ngIf="serviceRequestService.isPickUp"
          >
            {{ 'i18n.requestCredit.alternateTitle' | translate }}
          </h2>
        </ion-col>
      </ion-row>

      <!-- Row for Subtitle -->
      <ion-row class="subtitle-row">
        <ion-col size="12">
          <span data-cy="request-credit-page-subtitle-text">
            {{ 'i18n.requestCredit.provideOrderInfo' | translate }}
          </span>
        </ion-col>
      </ion-row>

      <!-- Row for Banner -->
      <ion-row *appShowSplit="[divisionDfgBannerFlag]" class="banner-row">
        <ion-col size="12">
          <span data-cy="request-credit-page-banner-text" class="promotions">
            <b>{{ 'i18n.common.note' | translate }}</b>
            {{ 'i18n.requestCredit.dfgBanner' | translate }}
            <br />
            <a
              class="banner-link"
              href="https://www.usfoods.com/deliveredfresh"
              data-cy="banner-link"
            >
              {{ 'i18n.requestCredit.dfgBannerLink' | translate }}</a
            >
            {{ 'i18n.requestCredit.dfgBanner2' | translate }}
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- SELECT ORDER NUMBER TEMPLATE -->
  <ng-template #orderNumber>
    <ion-card-title data-cy="order-options-label">
      {{ 'i18n.requestCredit.selectOrderNumber' | translate }}
      <span
        data-cy="order-select-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item
      data-cy="select-order-options-button"
      [class.placeholder]="!serviceRequestService?.selectedParams?.order"
      detail="true"
      type="button"
      (click)="openOrderOptionsModal()"
    >
      <ion-label data-cy="selected-order-options-text">
        {{ serviceRequestService?.selectedParams?.order ?
        ('i18n.requestCredit.orderInfo' | translate : { orderNumber:
        serviceRequestService?.selectedParams?.order?.orderHeader?.tandemOrderNumber
        || '-', deliveryDate:
        (serviceRequestService?.selectedParams?.order?.orderHeader?.confirmedDeliveryDate|
        date: 'M/d/yy':'GMT'), deliveryMethod:
        (getOrderTypeLabel(serviceRequestService?.selectedParams?.order?.orderHeader?.orderType
        ) | translate) || '-' }) : 'i18n.requestCredit.selectAnOrder' |
        translate }}
      </ion-label>
    </ion-item>
  </ng-template>

  <!-- SELECT PRODUCT TEMPLATE -->
  <ng-template #product>
    <ion-card-title data-cy="product-label">
      {{ 'i18n.requestCredit.selectProduct' | translate}}
      <span
        data-cy="product-select-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item
      data-cy="select-product-button"
      [class.placeholder]="!serviceRequestService?.selectedParams?.product"
      detail="true"
      type="button"
      (click)="openProductOptionsModal()"
    >
      <ion-label data-cy="selected-product-text">
        <span *ngIf="serviceRequestService.isPickUp" class="bold"
          >Pickup:
        </span>
        {{ serviceRequestService.selectedParams.product ? "#" +
        serviceRequestService.selectedParams?.product.productNumber + " - " +
        (serviceRequestService.selectedParams?.product.productDescription |
        titlecase) : 'i18n.requestCredit.selectAProduct' | translate }}
      </ion-label>
    </ion-item>
  </ng-template>

  <!-- MODEL NUMBER TEMPLATE -->
  <ng-template #modelNumber>
    <ion-card-title data-cy="model-number-label">
      {{ 'i18n.requestCredit.modelNumber' | translate }}&nbsp;{{
      'i18n.common.optionalInput' | translate }}
    </ion-card-title>
    <ion-item>
      <ion-input
        aria-label="model-number"
        data-cy="model-number-input"
        placeholder="{{ 'i18n.requestCredit.maxChar25' | translate }}"
        maxlength="25"
        type="text"
        [(ngModel)]="serviceRequestService.selectedParams.modelNumber"
      >
      </ion-input>
    </ion-item>
  </ng-template>

  <!-- INVOICE NUMBER TEMPLATE -->
  <ng-template #invoiceNumber>
    <ion-card-title data-cy="invoice-number-label">
      {{ 'i18n.requestCredit.invoiceNumber' | translate }}
    </ion-card-title>
    <ion-label class="invoice">
      #{{serviceRequestService.selectedParams?.order?.orderHeader?.invoiceNumber}}
    </ion-label>
  </ng-template>

  <!-- SERIAL NUMBER TEMPLATE  -->
  <ng-template #serialNumber>
    <ion-card-title data-cy="serial-number-label">
      {{ 'i18n.requestCredit.serialNumber' | translate }}&nbsp;{{
      'i18n.common.optionalInput' | translate }}
    </ion-card-title>
    <ion-item>
      <ion-input
        aria-label="serial-number"
        data-cy="serial-number-input"
        placeholder="{{ 'i18n.requestCredit.maxChar25' | translate }}"
        maxlength="25"
        type="text"
        [(ngModel)]="serviceRequestService.selectedParams.serialNumber"
      >
      </ion-input>
    </ion-item>
  </ng-template>

  <!-- SELECT ISSUE TEMPLATE -->
  <ng-template #issue>
    <ion-card-title data-cy="issue-label">
      {{ 'i18n.requestCredit.issue' | translate}}
      <span data-cy="issue-required-field-indicator-text" class="required-span">
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item
      data-cy="select-issue-button"
      [class.placeholder]="!serviceRequestService?.selectedParams?.issue"
      detail="true"
      type="button"
      (click)="openIssueOptionsModal()"
    >
      <ion-label data-cy="selected-issue-text">
        {{ serviceRequestService?.selectedParams.issue ?
        serviceRequestService?.selectedParams?.issue?.displayText :
        'i18n.requestCredit.selectIssue' | translate }}
      </ion-label>
    </ion-item>
  </ng-template>

  <!-- SELECT ISSUE DETAILS TEMPLATE -->
  <ng-template #issueDetails>
    <ion-card-title data-cy="issue-details-label">
      {{ 'i18n.requestCredit.issueDetails' | translate}}
      <span
        data-cy="issue-detail-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item
      data-cy="select-issue-details-button"
      [class.placeholder]="!serviceRequestService?.selectedParams?.issueDetails"
      detail="true"
      type="button"
      (click)="openIssueDetailsOptionsModal()"
    >
      <ion-label data-cy="selected-issue-details-text">
        {{ serviceRequestService?.selectedParams?.issueDetails ?
        serviceRequestService?.selectedParams?.issueDetails?.displayText :
        'i18n.requestCredit.selectIssueDetails' | translate }}
      </ion-label>
    </ion-item>
  </ng-template>
  <ng-template #reSealable>
    <ion-card-title data-cy="resealable-label" class="re-seal-label">
      <span
        *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile"
      >
        {{ 'i18n.requestCredit.pickUp.questionForPackaging' | translate }}
      </span>
      <span
        *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
      >
        {{ 'i18n.requestCredit.pickUp.questionForPackagingMobile1' | translate
        }}<br />
        {{ 'i18n.requestCredit.pickUp.questionForPackagingMobile2' | translate}}
      </span>
      <span
        data-cy="resealable-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-radio-group
      [class]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 'radio-options-touch' : 'radio-options'"
      [ngModel]="serviceRequestService?.selectedParams?.productInOriginalPackage"
      class="re-seal"
    >
      <ion-item
        class="no-border-item reseal-item"
        (click)="handleReSealable(true)"
      >
        <ion-radio
          mode="md"
          slot="start"
          [value]="true"
          data-cy="yes-reseeal-counts-radio"
          labelPlacement="end"
          >{{ 'i18n.common.yes' | translate }}</ion-radio
        >
      </ion-item>
      <ion-item
        class="no-border-item reseal-item"
        (click)="handleReSealable(false)"
      >
        <ion-radio
          mode="md"
          slot="start"
          [value]="false"
          data-cy="no-reseeal-counts-radio"
          labelPlacement="end"
          >{{ 'i18n.common.no' | translate }}</ion-radio
        >
      </ion-item>
    </ion-radio-group>
  </ng-template>

  <!-- PRODUCT RECEIVED TEMPLATE -->
  <ng-template #productReceived>
    <ion-card-title data-cy="product-received-label">
      {{ 'i18n.requestCredit.productReceived' | translate }}
      <span
        data-cy="product-received-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item>
      <ion-textarea
        data-cy="product-received-input"
        autoGrow="true"
        maxlength="100"
        placeholder="{{ 'i18n.requestCredit.enterProductName' | translate }}"
        required="true"
        rows="1"
        [(ngModel)]="serviceRequestService.selectedParams.productReceived"
        (ionBlur)="setShowRequiredProductReceivedInputLogic()"
        (ionChange)="setShowRequiredProductReceivedInputLogic()"
      >
      </ion-textarea>
    </ion-item>
    <div data-cy="product-received-char-counter-text" class="char-counter">
      {{ serviceRequestService?.selectedParams?.productReceived ?
      serviceRequestService?.selectedParams?.productReceived?.length : 0 }}/100
    </div>
    <ion-label
      *ngIf="serviceRequestService?.showRequiredProductReceivedInput?.value"
      data-cy="product-received-required-field-text"
    >
      {{ 'i18n.requestCredit.requiredField' | translate }}
    </ion-label>
  </ng-template>

  <!-- EMAIL TEMPLATE -->
  <ng-template id="email" #email>
    <div class="title-with-icon">
      <ion-card-title data-cy="email-label">
        {{ 'i18n.common.email' | translate }}
        <span
          data-cy="email-required-field-indicator-text"
          class="required-span"
        >
          {{ 'i18n.common.requiredInputIndicator' | translate }}
        </span>
      </ion-card-title>
      <ion-icon
        (click)="popoverInteraction($event, true)"
        name="information-circle"
        class="email-info-icon"
        data-cy="information-email-address-icon"
      >
      </ion-icon>
    </div>
    <ion-item>
      <ion-input
        aria-label="email"
        data-cy="email-input"
        placeholder="{{ 'i18n.common.emailPlaceholder' | translate }}"
        type="email"
        required="true"
        email
        [(ngModel)]="serviceRequestService.userEmail"
        (ionInput)="setEmail($event)"
      >
      </ion-input>
    </ion-item>
  </ng-template>

  <!-- SELECT QUANTITY TEMPLATE -->
  <ng-template #quantity>
    <ion-card-title data-cy="quantity-label">
      {{ 'i18n.requestCredit.selectQuantity' | translate}}
      <span
        data-cy="quantity-required-field-indicator-text"
        class="required-span"
        *ngIf="serviceRequestService.isPickUp"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-card-content class="quantity">
      <div
        class="select-quantity"
        [class.mobile-quantity]="platformService.platformType === platformService.platformEnum.mobile"
      >
        <ion-button
          data-cy="decrease-quantity-button"
          (click)="decrementQuantity()"
        >
          <ion-icon
            data-cy="decrease-quantity-icon"
            name="remove-outline"
            slot="icon-only"
          ></ion-icon>
        </ion-button>
        <ion-input
          aria-label="quantity-input"
          data-cy="quantity-input"
          inputmode="numeric"
          maxlength="3"
          placeholder="0"
          numeric
          (ionInput)="serviceRequestService.setSubmitButtonReady()"
          (ionFocus)="handleScroll()"
          [(ngModel)]="serviceRequestService.selectedParams.quantity"
        >
        </ion-input>
        <ion-button
          data-cy="increase-quantity-button"
          (click)="incrementQuantity()"
        >
          <ion-icon
            data-cy="increase-quantity-icon"
            name="add-outline"
            slot="icon-only"
          ></ion-icon>
        </ion-button>
      </div>
      <div class="select-quantity-units">
        <ion-item
          data-cy="select-quantity-units-button"
          [class.placeholder]="!serviceRequestService?.selectedParams?.quantityUnits"
          detail="true"
          type="button"
          (click)="openQuantityOptions($event)"
        >
          <ion-label data-cy="selected-quantity-units-text">
            {{ serviceRequestService?.selectedParams?.quantityUnits | translate
            }}
          </ion-label>
        </ion-item>
      </div>
    </ion-card-content>
  </ng-template>

  <!-- COMMENTS TEMPLATE -->
  <ng-template #comments>
    <ion-card-title data-cy="comments-label">
      {{ 'i18n.common.comments' | translate }}
      <span
        *ngIf="serviceRequestService?.commentsRequired"
        data-cy="comments-required-field-indicator-text"
        class="required-span"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
    </ion-card-title>
    <ion-item>
      <ion-textarea
        data-cy="comments-input"
        autoGrow="true"
        maxlength="120"
        placeholder="{{ (serviceRequestService?.commentsRequired ? 'i18n.requestCredit.commentPrompt' : 'i18n.requestCredit.commentPromptOptional') | translate }}"
        required="serviceRequestService?.commentsRequired"
        rows="1"
        [(ngModel)]="serviceRequestService.selectedParams.comments"
        (ionBlur)="setShowRequiredCommentsInputLogic()"
        (ionFocus)="handleScroll()"
        (ionChange)="setShowRequiredCommentsInputLogic()"
      ></ion-textarea>
    </ion-item>
    <div data-cy="comments-char-counter-text" class="char-counter">
      {{ serviceRequestService.selectedParams.comments ?
      serviceRequestService.selectedParams.comments.length : 0 }}/120
    </div>
    <ion-label
      *ngIf="serviceRequestService?.showRequiredCommentsInput?.value"
      data-cy="comments-required-field-text"
    >
      {{ 'i18n.requestCredit.requiredField' | translate }}
    </ion-label>
  </ng-template>

  <!-- PHOTO/FILE MESSAGE TEMPLATE -->
  <ng-template #requiredPhotoFileNote>
    <p class="file-note">{{ 'i18n.requestCredit.noteForFile' | translate }}</p>
    <ion-label
      *ngIf="serviceRequestService?.missingAttachment"
      data-cy="photo-file-required-field-text"
      class="required-photo-file"
    >
      {{'i18n.requestCredit.errorMessageMissingFiles' | translate}}
    </ion-label>
  </ng-template>

  <!-- ADD PHOTOS TEMPLATE -->
  <ng-template #photos>
    <ion-card-title data-cy="photos-label" class="title-with-tooltip">
      {{ 'i18n.requestCredit.addAPhoto' | translate }}
      <span
        data-cy="photo-required-field-indicator-text"
        class="required-span"
        *ngIf="serviceRequestService?.attachmentRequired"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
      <ion-icon
        id="hover-photos-trigger"
        data-cy="photos-information-icon"
        name="information-circle-outline"
      ></ion-icon>
      <ion-popover
        data-cy="photos-information-popover"
        class="accepted-file-types-popover"
        mode="ios"
        trigger="hover-photos-trigger"
        trigger-action="hover"
        (didPresent)="shouldCloseAcceptedFileTypesPopover($event)"
        (didDismiss)="removeWindowListener()"
      >
        <ng-template>
          <app-accepted-file-types-popover
            [fileTypesList]="acceptedPhotoTypes"
          ></app-accepted-file-types-popover>
        </ng-template>
      </ion-popover>
    </ion-card-title>
    <div class="photo-card">
      <!-- Photo 1 -->
      <div
        data-cy="photo-card-1"
        class="empty-image-box"
        [class.add-image-box]="!serviceRequestService?.selectedParams?.photos[0]"
      >
        <div
          *ngIf="!serviceRequestService?.selectedParams?.photos[0]"
          data-cy="add-photo-button"
          class="add-image"
          (click)="serviceRequestService.onAddPhoto()"
        >
          <img src="../../assets/icon/camera.svg" />
          <p data-cy="add-photo-text" class="add-photo-text">
            {{ 'i18n.common.add' | translate }}
          </p>
        </div>
        <ion-thumbnail
          *ngIf="serviceRequestService?.selectedParams?.photos[0]"
          slot="start"
        >
          <ion-img
            [src]="serviceRequestService?.selectedParams?.photos[0]?.webviewPath"
          ></ion-img>
          <div
            data-cy="delete-photo-button"
            class="delete-banner"
            (click)="serviceRequestService.onDeletePhoto(serviceRequestService.selectedParams.photos[0])"
          >
            {{ 'i18n.common.delete' | translate }}
          </div>
        </ion-thumbnail>
      </div>
      <!-- Photo 2 -->
      <div
        data-cy="photo-card-2"
        class="empty-image-box"
        [class.add-image-box]="!serviceRequestService?.selectedParams?.photos[1] && serviceRequestService?.selectedParams?.photos[0]"
      >
        <div
          *ngIf="!serviceRequestService?.selectedParams?.photos[1] && serviceRequestService?.selectedParams?.photos[0]"
          data-cy="add-photo-button"
          class="add-image"
          (click)="serviceRequestService.onAddPhoto()"
        >
          <img src="../../assets/icon/camera.svg" />
          <p data-cy="add-photo-text">{{ 'i18n.common.add' | translate }}</p>
        </div>
        <ion-thumbnail
          *ngIf="serviceRequestService?.selectedParams?.photos[1]"
          slot="start"
        >
          <ion-img
            [src]="serviceRequestService?.selectedParams?.photos[1]?.webviewPath"
          ></ion-img>
          <div
            data-cy="delete-photo-button"
            (click)="serviceRequestService.onDeletePhoto(serviceRequestService.selectedParams.photos[1])"
            class="delete-banner"
          >
            {{ 'i18n.common.delete' | translate }}
          </div>
        </ion-thumbnail>
      </div>
      <!-- Photo 3 -->
      <div
        data-cy="photo-card-3"
        class="empty-image-box"
        [class.add-image-box]="!serviceRequestService?.selectedParams?.photos[2] && (serviceRequestService?.selectedParams?.photos[0] && serviceRequestService?.selectedParams?.photos[1])"
      >
        <div
          *ngIf="!serviceRequestService?.selectedParams?.photos[2] && (serviceRequestService?.selectedParams?.photos[0] && serviceRequestService?.selectedParams?.photos[1])"
          data-cy="add-photo-button"
          class="add-image"
          (click)="serviceRequestService.onAddPhoto()"
        >
          <img src="../../assets/icon/camera.svg" />
          <p data-cy="add-photo-text">{{ 'i18n.common.add' | translate }}</p>
        </div>
        <ion-thumbnail
          *ngIf="serviceRequestService?.selectedParams?.photos[2]"
          slot="start"
        >
          <ion-img
            [src]="serviceRequestService?.selectedParams?.photos[2]?.webviewPath"
          ></ion-img>
          <div
            data-cy="delete-photo-button"
            (click)="serviceRequestService.onDeletePhoto(serviceRequestService.selectedParams.photos[2])"
            class="delete-banner"
          >
            {{ 'i18n.common.delete' | translate }}
          </div>
        </ion-thumbnail>
      </div>
    </div>
  </ng-template>

  <!-- ADD FILE TEMPLATE -->
  <ng-template #file>
    <ion-card-title data-cy="file-label" class="title-with-tooltip">
      {{ 'i18n.requestCredit.uploadAFile' | translate }}
      <span
        data-cy="file-required-field-indicator-text"
        class="required-span"
        *ngIf="serviceRequestService?.attachmentRequired"
      >
        {{ 'i18n.common.requiredInputIndicator' | translate }}
      </span>
      <ion-icon
        id="hover-file-trigger"
        data-cy="file-information-icon"
        name="information-circle-outline"
      ></ion-icon>
      <ion-popover
        data-cy="file-information-popover"
        class="accepted-file-types-popover"
        mode="ios"
        trigger="hover-file-trigger"
        trigger-action="hover"
        (didPresent)="shouldCloseAcceptedFileTypesPopover($event)"
        (didDismiss)="removeWindowListener()"
      >
        <ng-template>
          <app-accepted-file-types-popover
            [fileTypesList]="acceptedFileTypes"
          ></app-accepted-file-types-popover>
        </ng-template>
      </ion-popover>
    </ion-card-title>
    <div class="file-picker">
      <app-file-picker
        [platform]="platformService?.platformType"
        [dataCyTag]="'add-file-button'"
        [error]=""
        [file]="serviceRequestService?.selectedParams?.file"
        [showSpinner]="false"
        [showChangeButton]="true"
        (fileAddEvent)="serviceRequestService.onAddFile()"
        (processFileEvent)="serviceRequestService.onDropFile($event)"
        (fileDeleteEvent)="serviceRequestService.onDeleteFile()"
      >
      </app-file-picker>
    </div>
  </ng-template>

  <!-- ================ -->
  <!-- END OF TEMPLATES -->
  <!-- ================ -->

  <ion-grid [fixed]="true">
    <ion-card>
      <!-- Desktop/Tablet-->
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop || platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        <!-- Row 1 - Select Order Number, Select Product -->
        <ion-row>
          <ion-col
            [size]="platformService?.platformType === platformService?.platformEnum?.desktop ? 4.125: 5.625"
          >
            <ng-container [ngTemplateOutlet]="orderNumber"></ng-container>
          </ion-col>
          <ion-col
            *ngIf="serviceRequestService?.selectedParams?.product"
            offset="0.75"
            [size]="platformService?.platformType === platformService?.platformEnum?.desktop ? 4.125: 5.625"
          >
            <ng-container [ngTemplateOutlet]="product"></ng-container>
          </ion-col>
          <ion-col
            *ngIf=" platformService?.platformType === platformService?.platformEnum?.desktop  && serviceRequestService?.selectedParams?.order"
            size="2.25"
            offset="0.75"
          >
            <ng-container [ngTemplateOutlet]="invoiceNumber"></ng-container>
          </ion-col>
        </ion-row>

        <ng-container *ngIf="serviceRequestService?.selectedParams?.product">
          <ng-container>
            <!-- Row 2 - Select Issue, Select Issue Details -->
            <ion-row>
              <ion-col
                *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
                size="2.25"
              >
                <ng-container [ngTemplateOutlet]="invoiceNumber"></ng-container>
              </ion-col>

              <ion-col
                [size]="platformService?.platformType === platformService?.platformEnum?.tablet ? 4.125: 5.625"
                [offset]="platformService?.platformType === platformService?.platformEnum?.tablet ? 0.75 : 0"
              >
                <ng-container [ngTemplateOutlet]="issue"></ng-container>
              </ion-col>
              <ion-col
                offset="0.75"
                [size]="platformService?.platformType === platformService?.platformEnum?.tablet ? 4.125: 5.625"
              >
                <ng-container [ngTemplateOutlet]="issueDetails"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 3 - Email Address -->
            <ion-row *ngIf="!((panAppState.user$ | async).email)">
              <ion-col
                [size]="platformService?.platformType === platformService?.platformEnum?.tablet ? 12: 5.625"
              >
                <ng-container [ngTemplateOutlet]="email"></ng-container>
              </ion-col>
            </ion-row>
            <!-- Row 4 - Product Received (Issue Type === Wrong Product), Select Quantity -->
            <ion-row>
              <ng-container
                *ngIf="serviceRequestService?.selectedParams?.issueDetails?.code === '04'; else showQuantityOnly"
              >
                <ion-col
                  size="5.625"
                  [class.required]="serviceRequestService?.showRequiredProductReceivedInput?.value"
                >
                  <ng-container
                    [ngTemplateOutlet]="productReceived"
                  ></ng-container>
                </ion-col>
                <ion-col offset="0.75" size="5.625">
                  <ng-container [ngTemplateOutlet]="quantity"></ng-container>
                </ion-col>
              </ng-container>

              <ng-template #showQuantityOnly>
                <ion-col size="4">
                  <ng-container [ngTemplateOutlet]="quantity"></ng-container>
                </ion-col>
                <ion-col
                  *ngIf="serviceRequestService?.selectedParams?.issueDetails?.productResaleable"
                  offset="0.5"
                  size="4.5"
                >
                  <ng-container [ngTemplateOutlet]="reSealable"></ng-container>
                </ion-col>
              </ng-template>
            </ion-row>

            <!-- Row 5 - Comments -->
            <ion-row>
              <ion-col
                size="12"
                [class.required]="serviceRequestService?.showRequiredCommentsInput?.value"
              >
                <ng-container [ngTemplateOutlet]="comments"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 6 - File Message -->
            <ion-row>
              <ion-col size="12">
                <ng-container
                  [ngTemplateOutlet]="requiredPhotoFileNote"
                ></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 7 - File and Photo Inputs -->
            <ion-row>
              <ion-col size="5.625">
                <ng-container [ngTemplateOutlet]="photos"></ng-container>
              </ion-col>
              <ion-col offset="0.75" size="5.625">
                <ng-container [ngTemplateOutlet]="file"></ng-container>
              </ion-col>
            </ion-row>
          </ng-container>
        </ng-container>
      </ng-container>

      <!--  Mobile -->
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
      >
        <!-- Row 1 - Select Order Number -->
        <ion-row>
          <ion-col size="12">
            <ng-container [ngTemplateOutlet]="orderNumber"></ng-container>
          </ion-col>
        </ion-row>

        <ng-container *ngIf="serviceRequestService?.selectedParams?.product">
          <!-- Row 2 - Select Product -->
          <ion-row>
            <ion-col size="12">
              <ng-container [ngTemplateOutlet]="product"></ng-container>
            </ion-col>
          </ion-row>

          <!-- Invoice Number -->
          <ion-row>
            <ion-col size="12">
              <ng-container [ngTemplateOutlet]="invoiceNumber"></ng-container>
            </ion-col>
          </ion-row>

          <ng-container>
            <!-- Row 3 - Select Issue -->
            <ion-row>
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="issue"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 4 - Select Issue Details -->
            <ion-row *ngIf="serviceRequestService?.selectedParams?.issue">
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="issueDetails"></ng-container>
              </ion-col>
            </ion-row>
            <!-- Row 5 - Email Address (Only present if not in user account) -->
            <ion-row *ngIf="!((panAppState.user$ | async).email)">
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="email"></ng-container>
              </ion-col>
            </ion-row>
            <!-- Row 6 - Product Received (Issue Type === Wrong Product) -->
            <ion-row
              *ngIf="serviceRequestService?.selectedParams?.issueDetails && serviceRequestService?.selectedParams?.issueDetails?.code === '04'"
            >
              <ion-col
                size="12"
                [class.required]="serviceRequestService?.showRequiredProductReceivedInput?.value"
              >
                <ng-container
                  [ngTemplateOutlet]="productReceived"
                ></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 7 - Select Quantity -->
            <ion-row>
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="quantity"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 8 - Select reSealable -->
            <ion-row
              *ngIf="serviceRequestService?.selectedParams?.issueDetails?.productResaleable"
            >
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="reSealable"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 9 - Comments -->
            <ion-row>
              <ion-col
                size="12"
                [class.required]="serviceRequestService?.showRequiredCommentsInput?.value"
              >
                <ng-container [ngTemplateOutlet]="comments"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 10 - File Messaage -->
            <ion-row>
              <ion-col size="12">
                <ng-container
                  [ngTemplateOutlet]="requiredPhotoFileNote"
                ></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 11 - Select Photo -->
            <ion-row>
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="photos"></ng-container>
              </ion-col>
            </ion-row>

            <!-- Row 11 - Select Files  -->
            <ion-row>
              <ion-col size="12">
                <ng-container [ngTemplateOutlet]="file"></ng-container>
              </ion-col>
            </ion-row>
          </ng-container>
        </ng-container>
      </ng-container>

      <ion-row class="fill-space">
        <ion-col size="12"></ion-col>
      </ion-row>

      <!-- Row Final - Submit Button -->
      <ion-row>
        <ion-col size="12">
          <div class="submit-btn-container">
            <ion-button
              data-cy="submit-modal-button"
              [ngClass]="
              platformService.platformType !== platformService.platformEnum.mobile
                ? serviceRequestService.blockSubmission.value
                  ? 'usf-fill-disabled-dsktp-tblt-modal-button'
                  : 'usf-fill-green-dsktp-tblt-modal-button'
                : serviceRequestService.blockSubmission.value
                ? 'usf-fill-disabled-mobile-modal-button'
                : 'usf-fill-green-mobile-modal-button'
            "
              (click)="onSubmit()"
            >
              {{ 'i18n.common.submit' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-card>
  </ion-grid>
  <app-footer></app-footer>

  <ion-popover
    data-cy="email-info-popover"
    class="email-info-popover"
    [ngClass]="platformService?.platformType === platformService?.platformEnum?.desktop ? 'desktop' : 'touch'"
    [side]="platformService.platformType !== platformService.platformEnum.desktop ? 'end' : 'top'"
    alignment="center"
    #emailInfoPopover
    mode="ios"
    showBackdrop="false"
    [isOpen]="openPopover"
    (didDissmess)="popoverInteraction(undefined, false)"
  >
    <ng-template>
      <app-email-info-popover
        mode="ios"
        [platformType]="platformService.platformType === platformService.platformEnum.desktop ? 'desktop' : 'touch'"
      ></app-email-info-popover>
    </ng-template>
  </ion-popover>

  <ion-modal
    [isOpen]="serviceRequestService.showPickUpQuestionModal.value"
    (ionModalDidDismiss)="handlePickUpDismissBySlideDown($event)"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : !serviceRequestService.withIcon ? 'pick-up-request-small' :'pick-up-request-large'"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  >
    <ng-template>
      <app-pick-up-question-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [title]="serviceRequestService.pickupQuestion1"
        [subtitle]="serviceRequestService.pickUpQuestion2"
        [leftButtonText]="serviceRequestService.pickUpLeftButton"
        [rightButtonText]="serviceRequestService.pickUpRightButton"
        [withIcon]="serviceRequestService.withIcon"
        [isFrozen]="serviceRequestService.isFrozenModal"
        [leftIsTrue]="serviceRequestService.leftIsTrue"
        (dismissEvent)="handlePickupQuestionDismiss($event)"
      >
      </app-pick-up-question-modal>
    </ng-template>
  </ion-modal>
</ion-content>
